import { z } from 'zod';

export const CommunicationMethodChannelEnum = z.enum([
  'Email',
  'Phone',
  'AdditionalEmail',
  'AdditionalPhone',
  'AdditionalEmail',
]);

export const CommunicationMethodEnum = z.enum([
  'Fulfilment',
  'Billing',
  'Both',
]);

export type CommunicationMethodType = z.infer<typeof CommunicationMethodEnum>;
export type CommunicationMethodChannelType = z.infer<
  typeof CommunicationMethodChannelEnum
>;
